import {
  Action,
  PreloadedState,
  StateFromReducersMapObject,
  ThunkAction,
  configureStore,
} from '@reduxjs/toolkit';
import reducer from 'src/redux/reducers';

function createStore(preloadedState: PreloadedRootState) {
  return configureStore({
    reducer,
    preloadedState,
  });
}

export type AppStore = ReturnType<typeof createStore>;
export type PreloadedRootState = Partial<PreloadedState<RootState>>;
export type RootState = StateFromReducersMapObject<typeof reducer>;
export type AppDispatch = ReturnType<typeof createStore>['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default createStore;
